import { get,post } from "./baseService";

export async function getOpportunities(page,limit) {
  // /?${page}&${limit}
  const response = await get(`opportunities?page=${page}&limit=${limit}`, true);
  return response;
}

export async function getOpportunitiesEligibilties(code)
{
  const reponse=await get(`opportunities/eligibilities/${code}`,true);
  return reponse;
 
}

export function postOpportunitiesEligibilties(data) {
  const reponse= post('opportunities/check-eligibilities', data, true)
   return reponse;
}

export async function getOpportunitiesFilterFields() {
  const response = await get("opportunities/filter", true);
  return response;
}

export async function getFilterOpportunities(data) {
  const queryString = new URLSearchParams(data).toString();
  const response = await get(`opportunities/index?${queryString}`, true);
  return response;
}

export async function getOpportunity(code) {
  const response = await get(`opportunities/${code}`, true);
  return response;
}

export function getAllOpportunitiesAddedByUniversity(data) {
  return post('get-offer-added-by-university', data, false).then(response=>response);
}

export function getStudentFavoriteOpportunitiesList(data) {
  // console.log(data, 'get user opport')
  return post('users/get-favorite', data, true).then((response) => response)
}

export function deleteStudentFavoriteOpportunity(data) {
  return post('users/delete-favorite', data, true).then(response=>response)
}

export function addOpportunityInStudentFavoriteList(data) {
  return post('users/add-favorite', data, true).then(response=>{
      return response;
  })
}

export function getAllUniversities() {
  return post('get-all-universities', false).then(response=>response);
}

export function getAllCountries() {
  return post('get-countries', false).then(response=>response);
}

export function addOpportunity(data) {
  return post('add-opportunity', data, false).then(response=>console.log(response, 'this is the isse')).catch(err=>console.log(err, 'err'));
}
export function redeemOffer(data) {
  return post('redeem-offer', data, false).then(resp=>resp)
}